module.exports = __webpack_public_path__ + "static/thumb-salon-jordi-12fe02b2bc3ed1b6d32619af465a4b27.jpg";